import React, { useState, useEffect, useRef } from "react";
import { Link } from 'react-router-dom';
import { Col, Row, Card, Container, Breadcrumb } from 'react-bootstrap';
import GWformClient from '../../modalPopup/GWformClient';
import { Button } from 'primereact/button';
// Importing the image file
import staticInv from "../../assets/images/static_inv.png";
import videoInv from "../../assets/images/video_inv.png";
import threeDInv from "../../assets/images/3d_inv.png";
import weddingWebsites from "../../assets/images/website.svg";
import stationery from "../../assets/images/wedding.svg";
import socialmedia from "../../assets/images/socialmedia.png";
import logos from "../../assets/images/logos.png";
import hstag from "../../assets/images/hstag.png";
import moment from "moment";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import config from '../../config';
import { useClientAuth } from '../../context/ClientAuthContext';
import { Calendar } from 'primereact/calendar';
 
function Client_services() {
    const { ClientId, apiRequest } = useClientAuth();
    const [loading, setLoading] = useState(true);
    const [formsData, setFormsData] = useState([]);

    // State to track active item and content for the second column
    const [activeItem, setActiveItem] = useState(null);
    const [cardData, setCardData] = useState("Select an item to view details.");


    // Handle click on a list item
    const handleListItemClick = (item) => {
        setActiveItem(item.form_submission_id);
        setCardData(item);
    };


    /*---------------Month filter-------------------*/

    const currentDate = new Date();
    const [date, setDate] = useState(new Date(currentDate.getFullYear(), currentDate.getMonth(), 1));


    useEffect(() => {
        if (ClientId) {
            fetchForms(ClientId, date);
        }
    }, [ClientId, date]);
    
    useEffect(() => {
        // Check if activeItem still exists in the new formsData
        if (activeItem && !formsData.some(form => form.form_submission_id === activeItem)) {
            setActiveItem(null);
            setCardData(null);
        }
    }, [formsData]); // Runs whenever formsData updates

    const fetchForms = async (clientId, selectedDate) => {
        try {
            setLoading(true);

            // Extract month and year from the selectedDate
            const month = selectedDate.getMonth() + 1; // Months are 0-indexed in JS
            const year = selectedDate.getFullYear();

            const response = await apiRequest(
                `${config.apiBASEURL}/ClientFormRoutes/fetch-submitted-forms/${clientId}?month=${month}&year=${year}`,
                {
                    method: "GET",
                }
            );

            setFormsData(Array.isArray(response.data) ? response.data : []); // Ensure it's an array
        } catch (error) {
            console.error("Error fetching forms:", error);
            setFormsData([]); // Set empty array on error
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 3000);
        }
    };



    return (

        <>
            <div className="d-flex justify-content-end align-items-center mb-3">
                <p className="mb-0 me-2 text-secondary">Filter by Month</p>
                <Calendar value={date} onChange={(e) => setDate(e.value)} view="month" dateFormat="mm/yy" style={{ width: "150px" }} />
            </div>
            <Row className="mx-0 justify-content-center pt-3 serviceCol">
                <Col className={`first-col ${activeItem ? "col-3" : "col-12"} transition`}>
                    <ul className="sticky-top" style={{ top: "100px" }}>
                        {formsData.map((form) => (
                            <li
                                key={form.form_submission_id}
                                onClick={() => handleListItemClick(form)}
                                className={`clickable ${activeItem === form.form_submission_id ? "active" : ""}`}
                                style={{ height: "auto" }}
                            >
                                <Card className="border-0 shadow-sm p-2">
                                    <Card.Body className="border p-2" style={{ borderRadius: "5px" }}>
                                        <img
                                            src={staticInv}
                                            alt={form.form_name}
                                            className="mb-3"
                                            style={{ width: "60px", height: "60px" }}
                                        />
                                        <h6>{form.form_name}
                                            <small className="d-block">{form.type}</small>
                                        </h6>
                                    </Card.Body>
                                </Card>
                            </li>
                        ))}
                    </ul>
                </Col>
                <Col className={`second-col ${activeItem ? "col-9 show" : "col hide"} transition`}>
                    {cardData && cardData.steps && (
                        <Card className="border-0">
                            <Card.Header className="bg-light d-flex justify-content-between align-items-center">
                                <h6>
                                    <span className="text-secondary">{cardData.form_name}</span> -
                                    <b className="text-black"> {cardData.type}</b>
                                </h6>
                                <Button severity="danger" outlined className="border-0 p-0" icon="pi pi-times" aria-label="Close" onClick={() => setActiveItem(null)} />
                            </Card.Header>
                            <Card.Body>
                                {cardData.steps && Object.entries(cardData.steps).map(([stepKey, stepData], index) => {
                                    const stepName = Object.keys(stepData)[0]; // Get the actual step name
                                    return (
                                        <div key={index} className="allempList">
                                            <div className="rol-title">{stepName}</div>
                                            <ul className="clit_onfileDet">
                                                {stepData[stepName] && stepData[stepName].map((detail) => (
                                                    <li key={detail.form_data_id}>
                                                        <small className="d-block text-warning">{detail.field_label}</small>
                                                        {detail.response || "N/A"}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    );
                                })}
                            </Card.Body>
                        </Card>
                    )}
                </Col>
            </Row>
        </>
    );
}


export default Client_services;